<template>
    <div>
        <v-divider :class="['mt-5', 'mb-5']"></v-divider>
            <v-row dense>
                <v-col :cols="12" :sm="6" :offset-sm="0" :md="2" :offset-md="1" :lg="2" :offset-lg="1" :class="['pl-2', 'pr-2', 'pt-2', 'pb-2']">
                    <v-row dense>
                        <v-col :cols="6" :sm="12"><b>{{$t('components.qualityNotificationPositionComponent.sequence')}}</b> #{{this.sequence}}</v-col>
                        <v-col :cols="6" :sm="12"><i>{{$t('components.qualityNotificationPositionComponent.complainedWorkOrder', { workOrderDisplayName: this.qualityNotificationPosition.ComplainedWorkOrder.DisplayName})}}</i></v-col>
                    </v-row>
                </v-col>
                <v-divider vertical :class="['mt-2', 'mb-2', 'd-none d-sm-flex']"></v-divider>
                <v-col :cols="12" :sm="6" :offset-sm="0" :md="2" :lg="2" :class="['pl-2', 'pr-2', 'pt-2', 'pb-2']">
                    <v-row dense>
                        <v-col :cols="6" :sm="12"><b>{{$t('components.qualityNotificationPositionComponent.createdworkorder')}}</b></v-col>
                        <v-col v-if="this.qualityNotificationPosition.QualityWorkOrder == null" :cols="6" :sm="12"><i>{{$t('components.qualityNotificationPositionComponent.createdworkorderNotCreatedYet')}}</i></v-col>
                        <v-col v-else :cols="6" :sm="12">{{this.qualityNotificationPosition.QualityWorkOrder.DisplayName}}</v-col>
                    </v-row>
                </v-col>
                <v-divider vertical :class="['mt-2', 'mb-2', 'd-none d-md-flex']"></v-divider>
                <v-col :cols="12" :sm="4" :offset-sm="0" :md="2" :lg="2" :class="['pl-2', 'pr-2', 'pt-2', 'pb-2']">
                    <v-row dense>
                        <v-col :cols="6" :sm="12"><b>{{$t('components.qualityNotificationPositionComponent.state')}}</b></v-col>
                        <v-col :cols="6" :sm="12">
                            <v-chip v-if="[10].includes(this.qualityNotificationPosition.StatusId)" small color="gray">{{$t('components.qualityNotificationPositionComponent.states.new')}}</v-chip>
                            <v-chip v-if="[20, 30, 40, 50].includes(this.qualityNotificationPosition.StatusId)" small color="green">{{$t('components.qualityNotificationPositionComponent.states.accepted')}}</v-chip>
                            <v-chip v-if="[60].includes(this.qualityNotificationPosition.StatusId)" small color="green">{{$t('components.qualityNotificationPositionComponent.states.done')}}</v-chip>
                            <v-chip v-if="[80, 90].includes(this.qualityNotificationPosition.StatusId)" small color="red">{{$t('components.qualityNotificationPositionComponent.states.notAccepted')}}</v-chip>
                        </v-col>
                    </v-row>
                </v-col>
                <v-divider vertical :class="['mt-2', 'mb-2', 'd-none d-sm-flex']"></v-divider>
                <v-col :cols="12" :sm="4" :offset-sm="0" :md="2" :lg="2" :class="['pl-2', 'pr-2', 'pt-2', 'pb-2']">
                    <v-row dense>
                        <v-col :cols="6" :sm="12"><b>{{$t('components.qualityNotificationPositionComponent.delivery')}}</b></v-col>
                        <v-col v-if="this.qualityWorkOrderDeliveryFieldOrders.length === 0" :cols="6" :sm="12"><i>{{$t('components.qualityNotificationPositionComponent.deliveryNotCreatedYet')}}</i></v-col>
                        <v-col v-else :cols="6" :sm="12">
                            <abbr :title="$t('components.qualityNotificationPositionComponent.deliveryCalendarWeek.explanation')">{{$t('components.qualityNotificationPositionComponent.deliveryCalendarWeek.abbreviation')}}</abbr>
                            <span>&nbsp;</span>
                            <span>{{$IsoDateTime2Luxon(this.qualityWorkOrderDeliveryFieldOrders[this.qualityWorkOrderDeliveryFieldOrders.length-1].PlannedDate).weekNumber}}</span>
                        </v-col>
                    </v-row>
                </v-col>
                <v-divider vertical :class="['mt-2', 'mb-2', 'd-none d-sm-flex']"></v-divider>
                <v-col :cols="12" :sm="4" :offset-sm="0" :md="2" :lg="2" :class="['pl-2', 'pr-2', 'pt-2', 'pb-2']">
                    <v-row dense>
                        <v-col :cols="6" :sm="12">
                            <b>{{$t('components.qualityNotificationPositionComponent.installation')}}</b>
                        </v-col>
                        <v-col v-if="this.qualityWorkOrderInstallationFieldOrders.length === 0" :cols="6" :sm="12"><i>{{$t('components.qualityNotificationPositionComponent.installationNotCreatedYet')}}</i></v-col>
                        <v-col v-else :cols="6" :sm="12">
                            <abbr :title="$t('components.qualityNotificationPositionComponent.installationCalendarWeek.explanation')">{{$t('components.qualityNotificationPositionComponent.installationCalendarWeek.abbreviation')}}</abbr>
                            <span>&nbsp;</span>
                            <span>{{$IsoDateTime2Luxon(this.qualityWorkOrderInstallationFieldOrders[this.qualityWorkOrderInstallationFieldOrders.length-1].PlannedDate).weekNumber}}</span>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col :cols="12" :sm="6" :offset-sm="0" :md="7" :offset-md="1" :lg="8" :offset-lg="1" :xl="8" :offset-xl="1" :order="1">
                    <v-textarea
                        :rows="4"
                        :label="$t('components.qualityNotificationPositionComponent.problem')"
                        :value="this.description"
                        :disabled="false"
                        :readonly="true"
                        >
                    </v-textarea>
                    <!--
                    Do not display, since we do not know if there confidential text in it
                    <v-row>
                        <v-col>
                            <v-textarea
                                :rows="4"
                                :label="$t('components.qualityNotificationPositionComponent.solution')"
                                :value="this.solution"
                                :disabled="true"
                                >
                            </v-textarea>
                        </v-col>
                    </v-row> -->
                </v-col>
                <v-col :cols="12" :sm="5" :md="4" :offset-md="0" :lg="3" :offset-lg="0" :xl="3" :offset-xl="0" :order="2">
                    <b>{{$t('components.qualityNotificationPositionComponent.files')}}</b>
                    <v-list v-if="qualityNotificationPositionDocuments.length === 0" dense>
                        <v-list-item><i>{{$t('components.qualityNotificationPositionComponent.noFilesAttached')}}</i></v-list-item>
                    </v-list>
                    <v-list v-else dense>
                        <v-list-item v-for="document in qualityNotificationPositionDocuments" :key="document.DocumentId">
                            <v-list-item-icon :class="['mr-2']" v-if="document.IsDocument === true"><v-icon>mdi-file</v-icon></v-list-item-icon>
                            <v-list-item-icon :class="['mr-2']" v-else><v-icon>mdi-file-image</v-icon></v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{document.Name}}.{{document.Extension}}</v-list-item-title>
                                <v-list-item-subtitle
                                    @click="downloadDocument(qualityNotificationPosition.ComplainedWorkOrder.MasterOrderId, document)">
                                    <a>{{$t('components.qualityNotificationPositionComponent.fileDownload')}}</a>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-col>
            </v-row>
        </div>
</template>

<script>
import { QualityNotificationPositionStatus } from '../plugins/CustomerPortalApiClient/types';
import apiClient from '../plugins/CustomerPortalApiClient/client';

import {saveAs} from 'file-saver';
export default {
    name: 'QualityNotificationPositionComponent',
    props: {
        qualityNotificationPosition: Object
    },
    data: function() {
        return {
            qualityNotificationPositionDocumentsLoaded: false,
            qualityNotificationPositionDocuments: []
        }
    },
    computed: {
        qualityWorkOrder: {
            /**
             * @returns {(Object|null)} Gets the Workorder or null if not present
             */
            get: function() {
                if (this.qualityNotificationPosition.QualityWorkOrder !== undefined && this.qualityNotificationPosition.QualityWorkOrder !== null) {
                    return this.qualityNotificationPosition.QualityWorkOrder;
                }

                return null;
            }
        },
        sequence: {
            /**
             * @returns {Number} Gets the sequence of the QualityNotificationPosition.
             */
            get: function() {
                return this.qualityNotificationPosition.Sequence;
            }
        },
        solution: {
            /**
             * @return {String} Get the soltion of the QualityNotificationPosition.
             */
            get: function() {
                return this.qualityNotificationPosition.Solution;
            }
        },
        description: {
            /**
             * @return {String} Get the description of the QualityNotificationPosition.
             */
            get: function() {
                return this.qualityNotificationPosition.Description;
            }
        },
        qualityWorkOrderInstallationFieldOrders: {
            /**
             * @returns {Array<FieldOrder>} Gets an Array of FieldOrders.
             */
            get: function() {
                return apiClient.getInstallationFieldOrdersFromWorkOrder(this.qualityWorkOrder);
            }
        },
        qualityWorkOrderDeliveryFieldOrders: {
            /**
             * @returns {Array<FieldOrder>} Gets an Array of FieldOrders.
             */
            get: function() {
                return apiClient.getDeliveryFieldOrdersFromWorkOrder(this.qualityWorkOrder);
            }
        }
    },
    methods: {
        getWorkOrderDisplayName: function(workOrder) {
            return apiClient.getWorkOrderDisplayName(workOrder);
        },
        loadQualityNotificationPositionDocuments: function() {
            this.qualityNotificationPositionDocumentsLoaded = false;
            this.qualityNotificationPositionDocuments = [];

            apiClient.loadQualityNotificationPositionDocuments(
                this.$store.getters.token(),
                this.$store.getters.customerNumber(),
                this.qualityNotificationPosition.Id
            ).then((documents) => {
                this.qualityNotificationPositionDocuments = documents;
                this.qualityNotificationPositionDocumentsLoaded = true;
            }).catch((error) => {
                console.error(error);
                this.$snackbar(this.$t("components.qualityNotificationPositionComponent.loadQualityNotificationPositionDocuments"), 'red darken-1');
            });
        },
        downloadDocument(masterOrderId, document) {
            apiClient.loadDocumentsDownload(
                this.$store.getters.getToken(),
                this.$store.getters.customerNumber(),
                masterOrderId,
                document.FolderId,
                document.DocumentId
            ).then((documentToDownload) => {
                saveAs(documentToDownload.Base64Content, documentToDownload.FileName, 'base64');
            }).catch((error) => {
                console.error(error);
                this.$snackbar(this.$t("components.qualityNotificationPositionComponent.downloadDocument"), 'red darken-1');
            });
        },
        onceUsage() {
            return {
                qualityNotificationPositionStatus: new QualityNotificationPositionStatus(null, null, null)
            }
        }
    },
    created: function() {
        this.loadQualityNotificationPositionDocuments();
    }
}
</script>

<style>

</style>